module.exports = __webpack_public_path__ + "img/sample_header.c288a304.jpg";